/**
 * Authentication command handlers
 */

import { SessionManager } from '../utils/session.js';
import { formatSuccess, formatError, formatInfo } from '../utils/format.js';
import { cliError } from '../utils/errors.js';
import { runInteractiveLogin } from './interactive-login.js';

export async function authLogin(token?: string, apiUrl?: string): Promise<void> {
  if (!token) {
    // If no token is provided, run the interactive browser login
    await runInteractiveLogin(apiUrl);
    return;
  }

  try {
    SessionManager.saveToken(token, apiUrl);
    console.log(formatSuccess('Authentication saved'));
    console.log(`Token saved to ~/.hypertask/config.json`);
  } catch (error) {
    cliError(`Failed to save token: ${error}`);
  }
}

import { CLI_CONFIG } from '../config.js';

export async function authStatus(json?: boolean): Promise<void> {
  if (!SessionManager.hasConfig()) {
    const result = { authenticated: false, message: 'Not authenticated' };
    if (json) {
      console.log(JSON.stringify(result, null, 2));
    } else {
      console.log(formatInfo('Not authenticated'));
      console.log('Run: hypertask login');
    }
    return;
  }

  try {
    const config = SessionManager.loadConfig();
    const result = {
      authenticated: true,
      hasToken: !!config.token,
      apiUrl: config.apiUrl || CLI_CONFIG.DEFAULT_API_URL,
      configPath: `${process.env.HOME}/${CLI_CONFIG.CONFIG_DIR_NAME}/${CLI_CONFIG.CONFIG_FILE_NAME}`,
    };

    if (json) {
      console.log(JSON.stringify(result, null, 2));
    } else {
      console.log(formatSuccess('Authenticated'));
      console.log(`API URL: ${result.apiUrl}`);
      console.log(`Config: ${result.configPath}`);
    }
  } catch (error) {
    cliError(`Failed to read config: ${error}`);
  }
}

export async function authLogout(json?: boolean, tokenOverride?: string): Promise<void> {
  try {
    const hasTokenOverride = tokenOverride !== undefined;

    if (!hasTokenOverride) {
      SessionManager.clearConfig();
    }

    const result = hasTokenOverride
      ? { success: true, message: 'Saved authentication unchanged' }
      : { success: true, message: 'Logged out' };

    if (json) {
      console.log(JSON.stringify(result, null, 2));
    } else if (hasTokenOverride) {
      console.log(formatSuccess('Saved authentication unchanged'));
    } else {
      console.log(formatSuccess('Logged out'));
      console.log('Run: hypertask login to re-authenticate');
    }
  } catch (error) {
    cliError(`Failed to logout: ${error}`);
  }
}
